<template>
	<v-layout 	
		class="switchCampus" v-if="!$vuetify.breakpoint.smOnly" 
		style="bottom: 250px; right: -187px;">
		<v-btn dark small class="mx-0 my-0 mr-1" 	@click="gotoTucson" style="">
			MAIN CAMPUS
		</v-btn>
		<v-btn dark small class="mx-0 my-0 mr-1" 	@click="gotoPhoenix" style="">
			PHOENIX BIO
		</v-btn>
		<v-btn dark small class="mx-0 my-0 mr-1" 	@click="gotoUAHS" style="">
			UAHS
		</v-btn>
		<v-btn dark small class="mx-0 my-0" 	@click="gotoUASouth" style="">
			SIERRA VISTA
		</v-btn>
		</v-layout>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {

data () {
	return {}
},

computed: {
	...mapState({   	buildings: state => state.space.buildings,
						isSuperUser: state => state.user.isSuperUser, 
						stateMap: state => state.mapFunctions.stateMap,
				})
},

methods : {
	...mapMutations([ 	'',		]),
	...mapActions(['gotoCoordinates']),

	gotoTucson : function () {
		this.gotoCoordinates({ 'x': -110.95344, 'y': 32.231877 })
		this.stateMap.setZoom('17')
	},

	gotoPhoenix : function () {
		this.gotoCoordinates({ 'x': -112.066, 'y': 33.453 })
		this.stateMap.setZoom('18')
	},

	gotoUAHS : function () {
		this.gotoCoordinates({ 'x': -110.946, 'y': 32.2395 })
		this.stateMap.setZoom('18')
	},

	gotoUASouth : function () {
		this.gotoCoordinates({ 'x': -110.245, 'y': 31.567 })
		this.stateMap.setZoom('18')
	},
},
}

</script>

<style>
.switchCampus {
	position: absolute;
	 transform: rotate(90deg);

}
</style>



// WEBPACK FOOTER //
// src/components/SwitchCampus.vue